// import ApiService from '@/helpers/api.service';
// const API = new ApiService();
import ApiService2 from "@/helpers/api.service.ext";
const API2 = new ApiService2();
const WALLET_ENDPOINT = "/peddlr-wallet";
const S3_FOLDER = "adjusment-transactions"
import moment from "moment";
import { Storage } from 'aws-amplify';

export const state = {
  peddlrWalletDetails: {},
  peddlrWalletLimitLogs: [],
  peddlrWalletLimitLogsPageInfo: {
    total: 0
  },
  peddlrWalletTxn: [],
  peddlrWalletTxnPageInfo: {
    total: 0
  },
  cashInMethods: [],
  cashinMethodsLogs: [],
  cashinMethodsLogsPageInfo: {
    total: 0
  },
  kankolekAdjustmentsList: [],
  kankolekAdjustmentsListPageInfo: {
    total: 0
  },
  kankolekAccountList: [],
  kankolekAccountListPageInfo: {
    total: 0
  },
  errors: null,
};

export const mutations = {
  UPDATE_PEDDLR_WALLET(state, value) {
    state.peddlrWalletDetails = value;
  },
  UPDATE_LIMIT_LOGS(state, list){
    state.peddlrWalletLimitLogs = list;
  },
  UPDATE_LIMIT_LOGS_INFO(state, total){
      state.peddlrWalletLimitLogsPageInfo.total = total;
  },
  UPDATE_PEDDLR_WALLET_TXN(state, list){
    state.peddlrWalletTxn = list;
  },
  UPDATE_PEDDLR_WALLET_TXN_INFO(state, total){
      state.peddlrWalletTxnPageInfo.total = total;
  },
  UPDATE_KOLEK_CASHIN_METHODS(state, values){
    state.cashInMethods = values;
  },
  UPDATE_CASHIN_METHOD_LOGS(state, list){
    state.cashinMethodsLogs = list;
  },
  UPDATE_CASHIN_METHOD_LOGS_INFO(state, total){
      state.cashinMethodsLogsPageInfo.total = total;
  },
  UPDATE_KANKOLEK_ADJUSTMENTS_LIST(state, list){
    state.kankolekAdjustmentsList = list;
  },
  UPDATE_KANKOLEK_ADJUSTMENTS_INFO(state, total){
    state.kankolekAdjustmentsListPageInfo.total = total;
  },
  UPDATE_KANKOLEK_ACCOUNT_LIST(state, list){
    state.kankolekAccountList = list;
  },
  UPDATE_KANKOLEK_ACCOUNT_INFO(state, total){
    state.kankolekAccountListPageInfo.total = total;
  },
  SET_PROD_ERRORS(state, errors) {
    state.errors = errors;
  },
};

export const actions = {
  getPeddlrWalletDetails(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/get-wallet-details`, params)
        .then(({ data }) => {
          context.commit("UPDATE_PEDDLR_WALLET", data.message.rows[0]);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  updatePeddlrWalletLimit(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/update-wallet-limit`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  getPeddlrWalletLimitLogs(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/get-wallet-logs`, params)
        .then(({ data }) => {
          context.commit('UPDATE_LIMIT_LOGS', data.message.rows);
          context.commit('UPDATE_LIMIT_LOGS_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  getPeddlrWalletTxn(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/get-wallet-txn`, params)
        .then(({ data }) => {
          context.commit('UPDATE_PEDDLR_WALLET_TXN', data.message.rows);
          context.commit('UPDATE_PEDDLR_WALLET_TXN_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  getKankolekCashinMethods(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/get-cashin-methods`, params)
        .then(({ data }) => {
          context.commit('UPDATE_KOLEK_CASHIN_METHODS', data.message);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  updateWalletCashinMethodStatus(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/update-method-status`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  getKankolekCashinMethodLogs(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/get-cashin-method-logs`, params)
        .then(({ data }) => {
          context.commit('UPDATE_CASHIN_METHOD_LOGS', data.message.rows);
          context.commit('UPDATE_CASHIN_METHOD_LOGS_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  getAdjustmentTransactionList(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/list-adjustments`, params)
        .then(({ data }) => {
          context.commit('UPDATE_KANKOLEK_ADJUSTMENTS_LIST', data.message.rows);
          context.commit('UPDATE_KANKOLEK_ADJUSTMENTS_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  getKankolekAccountList(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/list-kankolek-merchants`, params)
        .then(({ data }) => {
          context.commit('UPDATE_KANKOLEK_ACCOUNT_LIST', data.message.rows);
          context.commit('UPDATE_KANKOLEK_ACCOUNT_INFO', data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  actionAdjustmentTransaction(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/${params.action}-adjustment`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  adjustmentAction(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/adjustment-action`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  invokeBulkProcessFunction(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${WALLET_ENDPOINT}/invoke-bulk-process`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.message);
          reject();
        });
    });
  },
  uploadAdjustmentExcelFile(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg","csv","xlsx","vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(365, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      if(params.type == 'csv'){
        metadata['contentType'] = 'text/csv; charset=utf-8';
      }
      if(params.type == 'xlsx'){
        metadata['contentType'] = 'text/xlsx';
      }
      if(params.type == "vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        metadata['contentType'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        let name = params.filename.split(".");
        params.filename = name[0]+ ".xlsx";
      }
      // console.log(">>>>>>>",metadata['contentType']);
      Storage.put(`${S3_FOLDER}/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(stored);

            resolve(stored.key.replace(params.folder + "/", ""));
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  }
};

